import { Injectable } from '@angular/core';
import { SharedModule } from '../shared.module';

const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class SortService {

	/**
	 * sortArray:
	 * Sort multi-dimensional array by a key
	 * Usage: this.someArray.items = this._sortService.sortArray(this.someArray.items, ['title', 'group']); 
	 * Usage: this.someArray.items = this._sortService.sortArray(this.someArray.items, ['date'], true);//reverse order 
	 * @param arr: array of items to sort:  nameOfArray[]
	 * @param keyArr : array of keys to sort by: ['keyOne', 'keyTwo']
	 * @param reverse : boolean : true/false
	 */

	 public sortArray(arr: any[], keyArr: any[], reverse:boolean = false) {
		if(_log) console.group('sortArray()');
		if(_log) console.log('arr', arr);
		if(_log) console.log('keyArr', keyArr);
		if(_log) console.log('reverse', reverse);
		if(_log) console.groupEnd();

		var sortOrder = 1;
		if (reverse) sortOrder = -1;
		return arr.sort(function (a, b) {
			var x = a, y = b;
			for (var i = 0; i < keyArr.length; i++) {
				x = x[keyArr[i]];
				y = y[keyArr[i]];
			}
			if(_log) console.log('compare: ', x, 'vs', y);
			return sortOrder * ((x < y) ? -1 : ((x > y) ? 1 : 0));
		});
	}



	/**
	 * Sort by date
	 * Usage: this.someArray.items = this._sortService.sortByDate(this.someArray.items, ['date']); 
	 * @param arr 
	 * @param key
	 * @param reverse : boolean : true/false
	 * @returns 
	*/
	public sortByDate(arr, key, reverse: boolean = false){
		if(_log) console.log('arr', JSON.parse(JSON.stringify(arr)));
		if(_log) console.log('key', key);
		var sortOrder = 1;
		if (reverse) sortOrder = -1;

		arr.sort(function (a, b) {
			var dateA: any = new Date(a[key]), 
				dateB: any = new Date(b[key]);
			if(_log) console.log('compare: ', dateA - dateB);
			return sortOrder * (dateA - dateB);
		});
		if(_log) console.log('arr: ', arr);
		return arr;
	}

}